<template>
    <div>
        <title-header title="Palavra do Presidente"></title-header>
        <div class="content">
            <header class="logo-header">
                <div class="logo"></div>
                <div class="header-text">
                    <h1>Amauri Sérgio Mortágua</h1>
                    <h2>Presidente</h2>
                </div>
            </header>
            <main>
                <header>
                    <h3 class="title" v-html="main_article.titulo"></h3>
                    <p>por <span>Amauri Mortágua</span>, 18/05/20 19h</p>
                </header>
                <article>
                    <p v-html="main_article.noticia"/>
                </article>
            </main>
            <footer>
                <p>Amauri Mortágua</p>
                <p>Presidente</p>
            </footer>
        </div>
    </div>
</template>

<script>
import TitleHeader from '../../../../components/title/title'
import CommentsList from "../components/comments-list";

import axios from 'axios';

export default {
    name: "text-presidente",
    components: {
        CommentsList,
        TitleHeader,
    },
    data() {
        return {
            main_article: {},
        }
    },
    methods: {
        getMainArticle(id){
            axios.get('get-noticia-atual/'+id)
                .then(res => {
                    this.main_article = res.data.noticia
                })
                .catch(error => {
                    console.log(error)
                })
        }
    },
    created() {
        this.getMainArticle(this.$route.params.id)
    }
}
</script>

<style scoped lang="scss">
.content {
    max-width: 1280px;
    @apply px-8 mx-auto border-b-2 border-light-gray mb-16;

    .logo-header {
        @apply flex items-center py-8 border-light-gray border-b-2;
        .logo {
            @apply rounded-lg mr-10;
            height: 200px;
            width: 200px;
            background: url("../../../../../img/AMAURI_SERGIO_MORTAGUA.jpeg") no-repeat center top;
            background-size: cover;
        }
        .header-text {
            h1 { @apply font-semibold py-2; }
            h2 { @apply font-medium py-2; }
        }
    }
    main {
        @apply mb-16;
        header {
            @apply flex justify-between py-4;
            .title {
                @apply font-medium text-xl;
            }
            p {
                @apply text-sm;
                span {
                    @apply text-tertiary;
                }
            }
        }
        p{
            @apply mb-4;
        }
    }
    footer{
        @apply mb-8;
        p{
            @apply mb-6;
        }
    }
}
</style>
